import { useRef } from "react";
import { Link, Outlet } from "react-router-dom";
import Logo from "../../assets/images/logo.jpg";
import useAuth from "../../hooks/useAuth";
import { Menu } from "primereact/menu";
import { routes } from "../../routes";

const AdmissionLayout = () => {
  const menuRight = useRef(null);
  const { auth } = useAuth();
  const profil = [
    {
      label: "" /* auth?.user
        ? auth?.user?.firstname + " " + auth?.user?.lastname
        : "", */,
      items: [
        {
          label: routes.dashboard.profil.name,
          icon: routes.dashboard.profil.icon,
          url: routes.dashboard.profil.path,
          command: (e) => {
            //console.log("mon profil");
          },
        },
        {
          label: routes.dashboard.mycandidates.name,
          icon: routes.dashboard.profil.icon,
          url: routes.dashboard.mycandidates.path,
          command: (e) => {
            console.log("mes candidatures");
          },
        },/* 
        {
          label: "Se déconnecter",
          icon: "pi pi-upload",
          command: (e) => {
            localStorage.clear();
            window.location.reload();
            console.log("se déconnecter");
          },
        }, */
      ],
    },
  ];
  return (
    <div className="admission_layout_container">
      <div className="admission_side_banner"></div>
      <div className="admission_wraper">
        <div className="admission_navbar">
          <Link to={routes.home}>
            <div className="logo">
              <img src={Logo} alt="logo_ecole229" />
            </div>
          </Link>
          <div className="admission_profile">
            <div className="">
              <div>{auth?.user?.firstname + " " + auth?.user?.lastname}</div>
              <div className="text-gray-400">{auth?.user?.email}</div>
            </div>
            <div
              className="pi pi-user admission_icon"
              aria-controls="popup_menu_right"
              onClick={(event) => menuRight.current.toggle(event)}
            ></div>
            <Menu model={profil} popup ref={menuRight} id="popup_menu_right" />
          </div>
        </div>
        <div className="admission_content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdmissionLayout;
